import React from "react";

export default function SQL_ANY() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_ANY</h1>
      <p>This is the SQL_ANY component generated from the SQL JSON.</p>
    </div>
  );
}
